import React from 'react';
import { StyleProp, StyleSheet, ViewStyle } from 'react-native';

import { LoadingSpinner } from '@/components/LoadingSpinner';
import { Box, Image } from '@/components/lib/components';
import { paymentMethodStyles } from '@/feature/deposit/styles';
import { useLogoUrl } from '@/hooks/use-logo-url';
import { common } from '@/styles/styles';

import { ds } from './lib/design.system';

type ImageContainerProps = {
    width: number;
    height: number;
    children: React.ReactNode;
    style: StyleProp<ViewStyle>;
};

type PaymentLogoProps = {
    source?: string[];
    width?: number;
    height?: number;
    containerStyle?: StyleProp<ViewStyle>;
    style?: StyleProp<ViewStyle>;
};

const ImageContainer = ({ width, height, children, style }: ImageContainerProps) => (
    <Box width={width} height={height} style={[styles.imageContainer, style]}>
        {children}
    </Box>
);

export const PaymentLogo: React.FC<PaymentLogoProps> = ({ source, width = 48, height = 36, containerStyle, style }) => {
    const { data: logoUrl, isLoading } = useLogoUrl(source);

    if (isLoading) {
        return (
            <ImageContainer width={width} height={height} style={containerStyle}>
                <LoadingSpinner size={24} displayLogo={false} />
            </ImageContainer>
        );
    }
    if (logoUrl) {
        return (
            <ImageContainer width={width} height={height} style={containerStyle}>
                <Image
                    source={{ uri: logoUrl }}
                    style={[
                        paymentMethodStyles.image,
                        style as StyleProp<{
                            width: number;
                            height: number;
                        }>,
                    ]}
                />
            </ImageContainer>
        );
    }

    return null;
};

const styles = StyleSheet.create({
    imageContainer: {
        marginRight: 16,
        borderWidth: 1,
        borderColor: ds.colorValue.border.strong,
        borderRadius: 8,
        ...common.borderCurve,
        ...common.alignCenter,
        ...common.justifyCenter,
    },
});
